import { render, staticRenderFns } from "./CompanyServicesTableGeneral.vue?vue&type=template&id=6edf2ff6&scoped=true&"
import script from "./CompanyServicesTableGeneral.vue?vue&type=script&lang=ts&"
export * from "./CompanyServicesTableGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf2ff6",
  null
  
)

export default component.exports